import React, { Component } from "react";
import { IconButton } from "@material-ui/core";
import { Translation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import { MenuItem } from "@material-ui/core";
import PlaylistPlayIcon from "@material-ui/icons/PlaylistPlay";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import { Link } from "react-router-dom";
import { PlayableTypes } from "./PlayerRef/PlayerRef";
import { AuthSrc } from "./../../util/AuthSrc";
import Badge from "@material-ui/core/Badge";

export default class PlayerPlaylist extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => this.setState({ anchorEl: event.currentTarget });
  handleClose = () => this.setState({ anchorEl: null });
  handleTrackPlay = (event, track) => {
    if (!track.withError) {
      const { handlePlayPlaylistTrack } = this.props;
      this.handleClose();
      handlePlayPlaylistTrack(track);
    }
  };

  playObjectRenderer = (playableType, t) => {
    switch (playableType) {
      case PlayableTypes.playlist:
        return this.playlistRenderer(t);
      case PlayableTypes.album:
        return this.albumRenderer(t);
      default:
        return null;
    }
  };

  albumRenderer = (t) => {
    const {
      classes,
      player: { playObject },
    } = this.props;
    if (playObject && playObject.id) {
      return (
        <Link
          className={classes.PlayListQuickLink}
          key={playObject?.id}
          to={`/search/album/${playObject.prodId}`}
          onClick={(e) => {
            this.handleClose();
          }}
        >
          {playObject && playObject.prodArtworkUrl ? (
            <img
              style={{ height: 44, width: 44 }}
              src={AuthSrc(playObject.prodArtworkUrl)}
              alt={playObject.name}
            />
          ) : (
            <MusicNoteIcon
              style={{
                fontSize: 40,
                color: "black",
                backgroundColor: "white",
                height: 64,
                width: 64,
              }}
            />
          )}
          <div>
            <span className={classes.playlistName}>{playObject.prodName}</span>
            <span className={classes.playlistType}>{t("player.album")}</span>
            <span className={classes.playlistTypeCatName}>
              {playObject.prodSubtitle}
            </span>
          </div>
        </Link>
      );
    }
  };

  playlistRenderer = (t) => {
    const {
      classes,
      player: { playObject },
    } = this.props;
    if (playObject && playObject.id) {
      return (
        <Link
          className={classes.PlayListQuickLink}
          key={playObject?.id}
          to={`/playlist/${playObject.id}`}
          onClick={(e) => {
            this.handleClose();
          }}
        >
          {playObject && playObject.artwork ? (
            <img
              style={{ height: 44, width: 44 }}
              src={AuthSrc(playObject.artwork)}
              alt={playObject.name}
            />
          ) : (
            <MusicNoteIcon
              style={{
                fontSize: 40,
                color: "black",
                backgroundColor: "white",
                height: 64,
                width: 64,
              }}
            />
          )}
          <div>
            <span className={classes.playlistName}>{playObject.name}</span>
            <span className={classes.playlistTypeCatName}>
              {playObject.categoryName}
            </span>
            <span className={classes.playlistType}>{t("player.playlist")}</span>
          </div>
        </Link>
      );
    }
  };

  render() {
    const {
      classes,
      player: { track, tracks, playableType },
    } = this.props;
    const { anchorEl } = this.state;
    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <IconButton
              aria-controls="action"
              aria-haspopup="true"
              onClick={this.handleClick}
              title="View All Tracks"
              aria-label="View All Tracks"
            >
              <PlaylistPlayIcon />
            </IconButton>
            <Menu
              keepMounted
              getContentAnchorEl={null}
              anchorOrigin={{
                horizontal: "left",
                vertical: "bottom",
              }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem>{this.playObjectRenderer(playableType, t)}</MenuItem>
              {tracks &&
                tracks.map((tr) => (
                  <MenuItem
                    onClick={(e) => {
                      this.handleTrackPlay(e, tr);
                    }}
                    className={tr.id === track.id ? classes.active : ""}
                  >
                    {tr && tr.prodArtworkUrl ? (
                      tr.withError ? (
                        <Badge
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          overlap="circle"
                          aria-label={t("player.error")}
                          title={t("player.error") + ": " + tr.errorMessage}
                          badgeContent={"!"}
                          color="secondary"
                        >
                          <img
                            style={{ height: 22, width: 22 }}
                            src={AuthSrc(tr.prodArtworkUrl)}
                            alt={tr.trackTitle}
                          />
                        </Badge>
                      ) : (
                        <img
                          style={{ height: 22, width: 22 }}
                          src={AuthSrc(tr.prodArtworkUrl)}
                          alt={tr.trackTitle}
                        />
                      )
                    ) : tr.withError ? (
                      <Badge
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        overlap="circle"
                        aria-label={t("player.error")}
                        title={t("player.error") + ": " + tr.errorMessage}
                        badgeContent={"!"}
                        color="secondary"
                      >
                        <MusicNoteIcon
                          style={{
                            fontSize: 40,
                            color: "black",
                            backgroundColor: "white",
                            height: 22,
                            width: 22,
                          }}
                        />
                      </Badge>
                    ) : (
                      <MusicNoteIcon
                        style={{
                          fontSize: 40,
                          color: "black",
                          backgroundColor: "white",
                          height: 22,
                          width: 22,
                        }}
                      />
                    )}
                    <span
                      style={{
                        width: "220px",
                        marginLeft: "10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {tr.trackTitle}
                    </span>
                  </MenuItem>
                ))}
            </Menu>
          </>
        )}
      </Translation>
    );
  }
}
